import { QuestionRegulatoryData, Questionnaire, QuestionnaireQuestion } from "../../Models/Surveys/SurveyDataModel";
import { BaseRegulationLogicManager } from "../BaseRegulationLogicManager";
import { ComplianceScoreResult, InventoryDetailsResponse } from "../../StateControllers/Survey/SurveyResponse/SurveyResponseModels";

export class InternationalPfasCustomLogicManager extends BaseRegulationLogicManager {
    public static InternationalPfasRegulationId = "b8630ed5-632a-4ef0-aa4e-faee463da90c";

    private readonly q1Id = "1";
    private readonly q5Id = "5";
    private readonly q6Id = "6";

    private readonly yesContainsPfasAnswer = "Yes (contains PFAS)";
    private readonly noNotKnownToContainPfasAnswer = "No (not known to contain PFAS)";

    constructor(
        questions: QuestionnaireQuestion[],
        overallQuestionnaire: Questionnaire,
        questionRegulatoryData: QuestionRegulatoryData[],
        selectedInventory: InventoryDetailsResponse | null,
        complianceScoreResult: ComplianceScoreResult | null
    ) {
        super(questions, overallQuestionnaire, questionRegulatoryData, selectedInventory, complianceScoreResult);
    }

    protected getAdditionalQuestionIndicesToHide = (question: QuestionnaireQuestion, questionIndex: number, indicesToHideOrShow: boolean[]) => {
        if (question.id !== this.q1Id) {
            return indicesToHideOrShow;
        }

        this.setQuestionHiddenState(indicesToHideOrShow, this.q5Id, !this.isNoNotKnownToContainPfasSelected());
        this.setQuestionHiddenState(indicesToHideOrShow, this.q6Id, !this.isYesContainsPfasSelected());

        return indicesToHideOrShow;
    }

    protected customIsQuestionRequired = (question: QuestionnaireQuestion) => {
        switch (question.id) {
            case this.q5Id:
                return this.isNoNotKnownToContainPfasSelected();
        }

        return false;
    }

    private setQuestionHiddenState(indicesToHideOrShow: boolean[], questionId: string, hidden: boolean) {
        const questionIndex = this._questions.findIndex(q => q.id === questionId);

        if (questionIndex >= 0) {
            indicesToHideOrShow[questionIndex] = hidden;
        }
    }

    private isYesContainsPfasSelected() {
        return this.getQ1Value() === this.yesContainsPfasAnswer;
    }

    private isNoNotKnownToContainPfasSelected() {
        return this.getQ1Value() === this.noNotKnownToContainPfasAnswer;
    }

    private getQ1Value() {
        return this._questions.find(q => q.id === this.q1Id)?.value ?? "";
    }
}
